import React from 'react';
import {
  BuildingOfficeIcon as HeroBuildingOffice,
  DocumentTextIcon as HeroDocumentText,
  MapPinIcon as HeroMapPin,
  CalendarIcon as HeroCalendar,
  HashtagIcon as HeroHashtag,
} from '@heroicons/react/24/outline';

export const BuildingOfficeIcon: React.FC<{ className?: string }> = ({ className = 'size-5' }) => (
  <HeroBuildingOffice className={className} aria-hidden="true" />
);

export const DocumentTextIcon: React.FC<{ className?: string }> = ({ className = 'size-5' }) => (
  <HeroDocumentText className={className} aria-hidden="true" />
);

export const MapPinIcon: React.FC<{ className?: string }> = ({ className = 'size-5' }) => (
  <HeroMapPin className={className} aria-hidden="true" />
);

export const CalendarIcon: React.FC<{ className?: string }> = ({ className = 'size-5' }) => (
  <HeroCalendar className={className} aria-hidden="true" />
);

export const HashtagIcon: React.FC<{ className?: string }> = ({ className = 'size-5' }) => (
  <HeroHashtag className={className} aria-hidden="true" />
);
